export default __webpack_public_path__ + "static/media/carholder-white.e48b1b09.png";